import config from "../config";
import { isEmpty } from "./nativeUtils";
/**
 * Sends a request for the Search API.
 * @param index index for the results
 * @param body request body
 * @param applicationId the application id to be sent in the header of the API request (optional)
 */
export default async function runRequest(index, body, applicationId) {
    try {
        return await makeApiRequest(index, body, applicationId);
    }
    catch {
        console.log("Call to search API failed.");
        return {};
    }
}
async function makeApiRequest(index, body, applicationId) {
    const response = await fetch(`${config.endpoint}query?indexes=${index}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(applicationId && { "Trimble-Application-Id": applicationId }),
        },
        body: JSON.stringify(body),
    });
    if (!response.ok) {
        throw new Error("Call to search API failed.");
    }
    else {
        const data = await response.json();
        if (data.queryId && !isEmpty(data.queryId)) {
            const encodedQueryId = encodeURIComponent(data.queryId);
            return { ...data, linkUrl: `${config.endpoint}redirect?queryId=${encodedQueryId}&target=` };
        }
        else {
            return data;
        }
    }
}
